module.exports = __webpack_public_path__ + "static/media/default_continent.2aeac727.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/Defaults/default_continent.jpg
// module id = 1121
// module chunks = 0